/**
 * The column template for the dashboard's day list, shared by its header and
 * every row -- the same arrangement, and the same reasoning, as
 * components/tasks/taskGrid.ts: one literal string, because Tailwind scans
 * source text and would never generate a template composed at runtime.
 *
 * Columns: status | title | project | due | priority | row actions.
 *
 * Distinct from TASK_GRID rather than shared with it: this list spans projects,
 * so it trades that list's counter cluster and assignee stack for the project
 * name, which is the column that actually orients you here.
 *
 * The leading track carries a StatusCell, so it takes the two widths TASK_GRID
 * gives its own: 5.25rem fits the dot plus "In progress", the longest label, and
 * 1rem fits the dot alone. It used to be 0.5rem -- the width of the dot and
 * nothing more -- back when the status here was only ever read.
 *
 * The project track pays part of that back, 8rem down to 7rem, which is what
 * TASK_GRID_WITH_PROJECT gives the same column. The rest comes out of the title,
 * which is the one track that can give.
 *
 * The trailing track is 4rem: three 1.25rem buttons with 0.125rem gaps between
 * them. It is wider than TASK_GRID's 2.75rem because this row carries a third
 * control the project list has no use for -- picking the task into the current
 * focus session, which is a question you only ask about work that is on today.
 *
 * It survives below `sm:`, where the project and priority tracks drop off,
 * because those buttons are the only one-click edit this card has left there.
 *
 * The due track survives at every width. It is the column the card is read
 * and triaged on: a deadline, or the word Due waiting to be given one.
 */
export const DAY_GRID =
  'grid items-center gap-x-3 grid-cols-[1rem_minmax(0,1fr)_4.5rem_4rem] sm:grid-cols-[5.25rem_minmax(0,1fr)_7rem_4.5rem_1rem_4rem]';
